export const APPLICANT_PAGE_SIZE = 50;

export function getApplicantQueryKey({ stage, search, sort, dateFrom, dateTo, source, attention, attentionReason, campaignStatus, nextAction }) {
  return JSON.stringify({
    stage: stage || 'ALL',
    search: search || '',
    sort: sort || 'newest',
    dateFrom: dateFrom || '',
    dateTo: dateTo || '',
    source: source || '',
    attention: attention || '',
    attentionReason: attentionReason || '',
    campaignStatus: campaignStatus || '',
    nextAction: nextAction || '',
  });
}

export function shouldLoadMoreApplicants({ loadedCount, total, loading }) {
  return !loading && Number(loadedCount) < Number(total || 0);
}

export function getNextApplicantPage({ page, loadedCount, total, loading }) {
  return shouldLoadMoreApplicants({ loadedCount, total, loading }) ? Number(page) + 1 : Number(page);
}

export function mergeApplicantPages(existingApplicants, nextApplicants) {
  const byId = new Map();
  for (const applicant of existingApplicants || []) {
    if (applicant?.id) byId.set(applicant.id, applicant);
  }
  for (const applicant of nextApplicants || []) {
    if (applicant?.id) byId.set(applicant.id, applicant);
  }
  return Array.from(byId.values());
}
